import {AppBar, IconButton, Toolbar, Typography} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {Close, MenuOpenRounded, MenuRounded} from '@mui/icons-material';
import ChatIcon from '@mui/icons-material/ChatOutlined';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {useRecoilState, useRecoilValue} from 'recoil';
import {UserType} from '@bidmii/common/lib/server/IServerApi';
import {leftMenuOpenState} from '../../../../recoil/navigation/NavigationRecoil';
import {userState} from '../../../../recoil/user/userAtom';
import NotificationMenu from '../../../NotificationMenu/NotificationMenu';
import LoginDialog from '../../components/LoginDialog';
import {BarMenu} from './BarMenu';
import UserProfileAvatarMenu from './UserProfileAvatarMenu';
import BidmiiProReferralBanner from '../../../BidmiiProSubscriptions/components/BidmiiProReferralBanner';
import {theme} from '../../../../Theme';
import BidmiiTooltip from '../../../../common/StyledComponents/BidmiiTooltip';

interface IProps {
  width: number;
  removeHeader: boolean;
  isAnonymous: boolean;
}

const useStyles = makeStyles(() => {
  return {
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: theme.palette.secondary.main,
      minHeight: 64,
      borderBottom: `1px solid ${theme.palette.gray.medium}`,
    },
    logo: {
      cursor: 'pointer',
      marginRight: 'auto',
      width: 100,
    },
    messagingIcon: {
      padding: 0,
      '& > *': {
        margin: theme.spacing(1),
        marginTop: 10,
      },
    },
  };
});

export const NavigationBar: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const user = useRecoilValue(userState);
  const [leftMenuOpen, setLeftMenuOpen] = useRecoilState(leftMenuOpenState);
  const {isAnonymous, removeHeader, width} = props;
  const isMobileLayout = width < 601;

  // const isMobile = width <= 600;

  const handleClickLogo = () => {
    if (user && user.userType === UserType.BIDDER) {
      history.push('/rfps');
    } else {
      history.push('/');
    }

    try {
      const element: HTMLIFrameElement = document.getElementById(
        'marketingIframe',
      ) as HTMLIFrameElement;
      const iFrame = element.contentWindow;
      if (iFrame !== null) {
        // Post message to trigger iFrame content to navigate home
        iFrame.postMessage('home', '*');
      }
    } catch (e) {}
  };

  const handleOpenMenu = () => {
    setLeftMenuOpen((curr) => !curr);
  };

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}
      elevation={0}
      style={{display: !removeHeader ? 'inherit' : 'none'}}>
      <BidmiiProReferralBanner main />

      <Toolbar style={{minHeight: 64}}>
        {!isMobileLayout && (
          <IconButton
            onClick={handleOpenMenu}
            style={{color: theme.palette.primary.main}}
            size="large"
            aria-label="Main Menu">
            {leftMenuOpen ? (
              <MenuOpenRounded fontSize="large" />
            ) : (
              <MenuRounded fontSize="large" />
            )}
          </IconButton>
        )}
        <img
          src={'https://cdn.bidmii.com/media/web_assets/logo.webp'}
          alt="Bidmii Logo"
          className={classes.logo}
          onClick={handleClickLogo}
        />
        <BarMenu width={width} />
        {user && (
          <>
            <BidmiiTooltip title="Messages">
              <IconButton
                className={classes.messagingIcon}
                onClick={() => history.push('/messages')}
                aria-label="messages"
                size="large">
                <ChatIcon color="primary" style={{fontSize: 22}} />
              </IconButton>
            </BidmiiTooltip>
            <NotificationMenu />
          </>
        )}
        {isMobileLayout ? (
          <>
            {/*!leftMenuOpen && <LoginDialog noButtons />*/}
            <IconButton
              onClick={handleOpenMenu}
              style={{
                color: theme.palette.primary.main,
                padding: 5,
                marginLeft: -6,
              }}
              aria-label="Main Menu"
              size="large">
              {leftMenuOpen ? (
                <Close style={{fontSize: 28, marginLeft: 7}} />
              ) : (
                <MenuRounded fontSize="large" />
              )}
            </IconButton>
          </>
        ) : (
          <UserProfile width={width} isAnonymous={isAnonymous} user={user} />
        )}
      </Toolbar>
    </AppBar>
  );
};

interface IUserProfileProps {
  width: number;
  user: any;
  isAnonymous: boolean;
}

const useProfileStyles = makeStyles((_theme) => {
  return {
    desktopAvatarPart: {
      color: theme.palette.primary.main,
      margin: '0 10px 0',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
  };
});

export const UserProfile: React.FC<IUserProfileProps> = (props) => {
  const classes = useProfileStyles();
  return (
    <>
      {props.width > 800 && (
        <Typography
          variant="subtitle2"
          gutterBottom
          className={classes.desktopAvatarPart}
          style={{fontSize: 15}}>
          {props.user && props.user.name ? props.user.name : ''}
        </Typography>
      )}
      {props.user && props.user.id && !props.isAnonymous ? (
        <UserProfileAvatarMenu />
      ) : (
        <LoginDialog />
      )}
    </>
  );
};
